import React from 'react';
import { Row, Col } from 'antd';
import { GlobalImage, ImageEntity, GlobalCta } from 'src/modules/global';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import { RowProps } from 'antd/lib/row';
// import { GlobalImage, ImageType } from 'src/modules/global';
// import { Row, Col } from 'antd';
// import { rowDefaultProps } from 'src/utils/grid';
import styles from './LayoutBlockHero.module.scss';
import Link from 'next/link';

const rowProps: RowProps = { gutter: [40, 20] };

export interface LayoutBlockHeroProps {
  title: string;
  subline?: string | React.ReactNode;
  label?: string;
  image: ImageEntity;
  link?: string;
  cta?: CtaProps;
  button?: CtaProps;
}

const LinkWrapper = ({ link, children }) => {
  if (link) {
    return (
      <Link href={link} as={link}>
        <a>{children}</a>
      </Link>
    );
  } else {
    return children;
  }
};

const LayoutBlockHero: React.FunctionComponent<LayoutBlockHeroProps> = (
  props: LayoutBlockHeroProps
) => {
  const { image, subline, title, label, link = '', cta } = props;
  //Remove the caption from the hero
  /* eslint-disable no-unused-vars */
  const { caption, ...imageProps } = image || { url: null };
  /* eslint-enable no-unused-vars */
  return (
    <div className={styles.container}>
      <Row {...rowProps}>
        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 8, order: 0 }}
          className={styles.textContainer}>
          <div className={styles.innerContainer}>
            {label && (
              <LinkWrapper link={link}>
                <span className={styles.label}>{label}</span>
              </LinkWrapper>
            )}
            <LinkWrapper link={link}>
              <h2 className={styles.title}>{title}</h2>
            </LinkWrapper>
            {React.isValidElement(subline)
              ? subline
              : typeof subline === 'string' && (
                  <LinkWrapper link={link}>
                    <span
                      className={styles.subline}
                      dangerouslySetInnerHTML={{ __html: subline }}
                    />
                  </LinkWrapper>
                )}
            {!!cta && <GlobalCta {...cta} />}
          </div>
        </Col>
        <Col xs={{ span: 24, order: 0 }} sm={{ span: 24, order: 0 }} md={{ span: 16, order: 1 }}>
          <GlobalImage {...imageProps} link={link} ratio={3 / 2} />
        </Col>
      </Row>
    </div>
  );
};

export default LayoutBlockHero;
